import { useContext } from 'react';
import { DentalDataContext } from '../providers/DentalDataProvider';
function useDentalDataContext() {
    return useContext(DentalDataContext);
}
export default useDentalDataContext;
